import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, ElementRef, forwardRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MatPaginator, MatSort, MatDialog, MatDialogRef } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { AddSubmittingEntityDialogComponent } from './add-submitting-entity-dialog.component';

import { ModuleConfiguration } from '../submission.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import { SubmittingEntityModel } from '../models/SubmittingEntityModel';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { Subject } from 'rxjs/Subject';
import { DeleteSubmissionConfirmationDialogComponent } from './delete-submission-confirmation-dialog.component';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { AppConfigurationService } from '../../core/services/AppConfigurationService';

@Component({
  selector: 'brd-submitting-entity-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => SubmittingEntityTileComponent) }],
  templateUrl: './submitting-entity-tile.component.html',
  styleUrls: ['./submitting-entity-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmittingEntityTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'allowedDataSetsCommaSeperated', 'actions'];
  dataSource: StoreDataSource<SubmittingEntityListModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  allSubmittingEntities: SubmittingEntityListModel[] = [];
  editPermission = 'SubmissionModule.SubmittingEntity:Edit';
  submittingEntities$: Observable<SubmittingEntityListModel[]>;
  manageSubmittingEntities: boolean = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;

  constructor(private store: Store<TileState<SubmittingEntityListModel, SubmittingEntityModel>>,
              private router: Router,
              private dialog: MatDialog,
              elementRef: ElementRef,
              private tileContainer: TileContainer,
              private appConfigurationService: AppConfigurationService) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
    this.manageSubmittingEntities = !appConfigurationService.configuration.isDelegatingSubmittingEntityManagementToOtherSystem;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.dataSource = new StoreDataSource<SubmittingEntityListModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getSubmittingEntityList),
      this.store.select(fromStore.getSubmittingEntityListTotalCount),
      this.store.select(fromStore.getSubmittingEntityListLoading),
      (p, s, search) => new actions.QueryListAction(ModuleConfiguration.moduleName,
        SubmittingEntityListModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          searchTerm: search.searchControl.value
        }),
      this.sort,
      this.search
    );
    this.loading$ = this.store.select(fromStore.getSubmittingEntityListLoading);
  }

  selectItem(item: SubmittingEntityListModel) {
    this.router.navigateByUrl('submitting-entity-workspace/' + item.key);
  }

  showAdd(): void {
    this.dialog.open(AddSubmittingEntityDialogComponent, {
      panelClass: 'customized-dialog',
      width: '648px',
      ariaLabel : 'Add Submitting Entity'
    });
  }

  delete(element: any) {
    this.dialog.open(DeleteSubmissionConfirmationDialogComponent,
      {
        panelClass: 'customized-dialog',
        width: '648px',
        data:
        {
          name: element.name,
          key: element.key
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/components/submitting-entity-tile.component.ts